import { IonButton, IonHeader, IonModal, IonSpinner, IonToolbar } from "@ionic/react";
import { getAuth } from "firebase/auth";
import { useState } from "react";
import { APIService } from "../network/APIService";

const ChangePasswordModal = ({ isOpen, handleModalDismiss }: { isOpen: boolean; handleModalDismiss: () => void }) => {
  const [sendingEmail, setSendingEmail] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSendPasswordResetEmail = async () => {
    setSendingEmail(true);
    const email = getAuth().currentUser?.email!;
    const emailSent = await APIService.requestPasswordReset(email);
    if (emailSent) {
      setErrorMessage("");
      await APIService.signOutUser();
    } else {
      setErrorMessage("Failed to sent password reset email.");
    }
    setSendingEmail(false);
  };

  return (
    <IonModal backdropDismiss={false} isOpen={isOpen} className="changePasswordModal">
      <IonHeader>
        <IonToolbar>
          <div className="modalToolbarContent">
            <div className="modalToolbarSides" />
            <p>Change Password</p>
            {sendingEmail ? (
              <div className="modalToolbarSides">
                <IonSpinner name="bubbles" />
              </div>
            ) : (
              <div className="modalToolbarSides" />
            )}
          </div>
        </IonToolbar>
      </IonHeader>
      <div className="modalMainContent">
        <p className="modalConfirmationText">Send an email to reset your password?</p>
        <p className="modalConfirmationText">User: {getAuth().currentUser?.email}</p>
        <p style={{ marginTop: "10px", fontSize: "14px", fontFamily: "av-bold" }} className="modalConfirmationText">
          Note that clicking Send will sign you out
        </p>
        {errorMessage && <p className="modalErrMsg">{errorMessage}</p>}
      </div>
      <div className="modalFooterButtonsContainer">
        <IonButton
          disabled={sendingEmail}
          className="cancelBtn"
          onClick={() => {
            setErrorMessage("");
            handleModalDismiss();
          }}
        >
          Cancel
        </IonButton>
        <IonButton
          disabled={sendingEmail}
          id="sendEmailBtn"
          className="yellowBtn"
          onClick={handleSendPasswordResetEmail}
        >
          Send
        </IonButton>
      </div>
    </IonModal>
  );
};

export default ChangePasswordModal;
